module.exports = __webpack_public_path__ + "media/images/footer/illu-dda020e455ca9e190101e863b2afdee6.svg";